import React from 'react';
import PropTypes from 'prop-types';
import BreadcrumbItem from "../component/BreadcrumbItem/BreadcrumbItem";
import Page from "../component/Page/Page";
import StockLevelForm from "./StockLevelForm";

class StockLevelFormPage extends React.Component {

  constructor(props) {
    super(props);
    const bizLocationId = props.match.params.bizLocationId;
    this.state = {bizLocationId}
  }

  render() {
    const {match, history} = this.props;
    const {bizLocationId = null} = this.state;
    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Estoque"/>,
      <BreadcrumbItem key={2} title="Lista de níveis de estoque" to="/list/stock-levels"/>,
      <BreadcrumbItem key={3} title="Dados de nível de estoque" active={true}/>];
    return (
        <Page title="Dados do nível de estoque" breadcrumbs={breadcrumbs}>
          <StockLevelForm bizLocationId={bizLocationId} match={match}
                          history={history}/>
        </Page>
    );
  }
}

StockLevelFormPage.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default StockLevelFormPage;


// WEBPACK FOOTER //
// ./src/stockLevel/StockLevelFormPage.js